// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"6e53487c","787":"e8f42ac7"}[chunkId] + ".chunk.js";
};